import { AxiosError } from "axios";
import { Shinsei } from "@/types/Shinsei";
import { Ref, ref } from "vue";
import { FormUtil } from "@/utils/FormUtil";
import { useForm } from '@/composable/form/form';
import { DialogService } from "@/service/DialogService";
import { ShinseiService } from "@/service/ShinseiService";

export function useUpdate() {
  const isUpdateing = ref(false)
  const { removeAllError } = useForm()
  const srv = new ShinseiService()

  // 入力内容を更新する
  const update = async (form: Ref<Shinsei>): Promise<number | null> => {
    isUpdateing.value = true;
    DialogService.nowloading('申請処理中...');
    let returnval: number | null;

    return srv.again(form.value).then(res => {
      if (res !== null) {
        DialogService.info({
          text: `申請しました`
        }, true);
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し処理に失敗しました'
        }, true);
      }
      isUpdateing.value = false;
      returnval = res;
    }).catch(e => {
      // 一回全部消す
      removeAllError(form.value)
      const val = Object.entries(form.value).find((key, data) => { 
        if(key[0] === form.value.shinsei_type_str){
          return data
        }
      })
      removeAllError(val?.[1])

      const err = e as AxiosError<any>;
      FormUtil.setLaravelError(form.value, err);
      returnval = null;
    }).then(() => {
      /* --- finaly処理 --- */
      // 更新中フラグを解除
      isUpdateing.value = false;
      return returnval;
    })
  }

  return {
    isUpdateing,
    update,
  }
}
